import { render, staticRenderFns } from "./AutobuyerIntervalLabel.vue?vue&type=template&id=097c2ad6&scoped=true"
import script from "./AutobuyerIntervalLabel.vue?vue&type=script&lang=js"
export * from "./AutobuyerIntervalLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097c2ad6",
  null
  
)

export default component.exports